// extracted by mini-css-extract-plugin
module.exports = {"user-layout-description":"style_user-layout-description__5e8vu"};